var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JFlex',{staticClass:"s-items-center"},[_c('JSelect',_vm._g({attrs:{"options":_vm.insurers,"value":_vm.value}},_vm.$listeners)),(_vm.isLoading)?_c('JSpinner',{attrs:{"type":"dots","delay":200}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }